import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "home" */ '@/views/Home.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/duplicates',
    name: 'detail',
    component: () => import(/* webpackChunkName: "duplicates" */ '@/views/Duplicates.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/login/:store_id?',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue')
  },
  {
    path: '/nologin',
    name: 'Nologin',
    component: () => import('@/views/Nologin.vue')
  },
  {
    path: '/nrs_login',
    name: 'nrs_login',
    component: () => import(/* webpackChunkName: "NRSLogin" */ '../views/NRSLogin.vue')
  },
  {
    path: '/nrshome',
    name: 'nrshome',
    component: () => import(/* webpackChunkName: "NRSHome" */ '@/views/NRSHome.vue'),
    meta: {
      requiresNRS: true
    }
  },
  {
    path: '/odareports',
    name: 'odareports',
    component: () => import(/* webpackChunkName: "NRSHome" */ '@/views/ODAHome.vue'),
    meta: {
      requiresNRS: true
    }
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      next()
    } else {
      next({
        path: '/login',
        params: { nextUrl: to.fullPath }
      })
    }

  } else {

    if (to.matched.some(record => record.meta.requiresNRS)) {
      if (store.getters.isLoggedNRS) {
        next()
      }
    } else {
      next()
    }

  }
})

export default router
